module.exports = __webpack_public_path__ + "media/sell-person.5fd92c56.wav";